import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './dialog';
import { Switch } from './switch';
import { useGameStore } from '../../store/gameStore';
import { Settings, MessageSquare, Keyboard } from 'lucide-react';

/**
 * SettingsMenu - Modal for toggling game settings
 * 
 * @param {boolean} open - Whether the modal is open
 * @param {function} onClose - Called when modal should close
 */
export const SettingsMenu = ({ open, onClose }) => {
  const selectedTheme = useGameStore((state) => state.selectedTheme);
  const settings = useGameStore((state) => state.settings) || {};
  const toggleTooltips = useGameStore((state) => state.toggleTooltips);
  const toggleKeyboardShortcuts = useGameStore((state) => state.toggleKeyboardShortcuts);

  const themeAccent = {
    noir: '#DC143C',
    '90s_nyc': '#FF6B35',
    miami_vice: '#FF1493',
  }[selectedTheme || 'noir'];

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="max-w-sm bg-slate-900 border-2"
        style={{ borderColor: themeAccent }}
      >
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-white flex items-center gap-2">
            <Settings className="w-5 h-5" style={{ color: themeAccent }} />
            Settings
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          {/* Tooltips Toggle */}
          <div className="flex items-center justify-between py-3 border-b border-slate-700/50">
            <div className="flex items-center gap-3">
              <MessageSquare className="w-4 h-4 text-gray-400" />
              <div>
                <p className="text-sm text-white font-medium">Show Tooltips</p>
                <p className="text-xs text-gray-500">Display info on hover</p>
              </div>
            </div>
            <Switch
              checked={settings.tooltipsEnabled ?? true}
              onCheckedChange={toggleTooltips}
            />
          </div>

          {/* Keyboard Shortcuts Toggle */}
          <div className="flex items-center justify-between py-3">
            <div className="flex items-center gap-3">
              <Keyboard className="w-4 h-4 text-gray-400" />
              <div>
                <p className="text-sm text-white font-medium">Keyboard Shortcuts</p>
                <p className="text-xs text-gray-500">Enable hotkey controls</p>
              </div>
            </div>
            <Switch
              checked={settings.keyboardShortcutsEnabled ?? true}
              onCheckedChange={toggleKeyboardShortcuts}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SettingsMenu;
